export const LOAD_MUNICIPIOS = 'LOAD_MUNICIPIOS';
export const MUNICIPIO_ERROR = 'MUNICIPIO_ERROR';
export const MUNICIPIO_GET_ERRORS = 'MUNICIPIO_GET_ERRORS';
export const MUNICIPIOS_DATA = 'MUNICIPIOS_DATA';
export const STORE_MUNICIPIO = 'STORE_MUNICIPIO';
export const GET_MUNICIPIO = 'GET_MUNICIPIO';
export const REMOVER_MUNICIPIO = 'REMOVER_MUNICIPIO';
export const SHOW_MUNICIPIO = 'SHOW_MUNICIPIO';
export const UPDATE_MUNICIPIO = 'UPDATE_MUNICIPIO';
